import { useState } from 'react'
import { EuiButton } from '@equipmentshare/ds2'
import useCancelTransactionHandler from 'views/reports/effects/cancel-transaction'
import { getRefetchTransactionQueries } from 'views/reports/utils'

export const refetchQueries = [
	...getRefetchTransactionQueries(),
	'StoreParts',
]

export type ConfirmCancellationButtonsProps = {
  closePopover: () => void,
  transactionId: number,
}

export default function ConfirmRejectionButtons( { closePopover, transactionId }: ConfirmCancellationButtonsProps ) {
	const cancelTransaction = useCancelTransactionHandler( { refetchQueries } )
	const [ isSaving, setIsSaving ] = useState( false )

	const onReject = async() => {
		setIsSaving( true )
		try {
			await cancelTransaction( transactionId )
		} catch ( e ) {
			setIsSaving( false )
		}
		closePopover()
	}

	return (
		<>
			<EuiButton
				color="text"
				onClick={closePopover}
			>
				Cancel
			</EuiButton>
			<EuiButton
				id="reject-btn"
				fill
				color="danger"
				isLoading={isSaving}
				onClick={onReject}
			>
				Reject
			</EuiButton>
		</>
	)
}
